jQuery(document).ready(function () {
  jQuery('.wc-proceed-to-checkout button[name="update_cart_trigger"]').prop('disabled', true);

  jQuery('#ajax-coupon-redeem input[type="submit"]').click(function (ev) {
    var code = jQuery("input#coupon").val();

    var data = {
      action: "spyr_coupon_redeem_handler",
      coupon_code: code,
    };

    jQuery.post(woocommerce_params.ajax_url, data, function (returned_data) {
      if (returned_data.result == "error") {
        jQuery("p.result").html(returned_data.message);
      } else {
        window.location.href = returned_data.href;
      }
    });

    ev.preventDefault();
  });

  jQuery('.woocommerce-cart-form .product-quantity input').change(function (e) {
    console.log('test change');
    jQuery('.wc-proceed-to-checkout button[name="update_cart_trigger"]').prop('disabled', false);
  });

  jQuery(document).on('click', '.wc-proceed-to-checkout button[name="update_cart_trigger"]', function (e) {
    console.log('test click');
    jQuery('.woocommerce-cart-form button[name="update_cart"]').click();
  });

});
